import { Injectable } from "@angular/core";
import { DbDaoBase } from "../../../gyzmo-commons/dao/db/base/db.dao.base";
import { NotImplementedError } from "../../../gyzmo-commons/helpers/notImplementedError";
import { AppSqlProvider } from "../../../gyzmo-commons/persistence/app.sql.provider";
import { LoggerService } from "../../../gyzmo-commons/services/logs/logger.service";
import { FtRecord } from "../../models/frRecord.model";

@Injectable({
    providedIn: "root",
})
export class FtRecordDbDao extends DbDaoBase<FtRecord> {
    constructor(logger: LoggerService,
                private sqlProvider: AppSqlProvider) {
        super(logger);
    }

    public async createIndexes(): Promise<void> {
        let query = `CREATE INDEX IF NOT EXISTS idx_${ FtRecord.TABLENAME }_object ON ${ FtRecord.TABLENAME }(object);`;
        await this.sqlProvider.query(query, [])
            .catch(reason => {
                this.logSqlError(reason);
            });

        query = `CREATE INDEX IF NOT EXISTS idx_${ FtRecord.TABLENAME }_isActive ON ${ FtRecord.TABLENAME }(isActive);`;
        await this.sqlProvider.query(query, [])
            .catch(reason => {
                this.logSqlError(reason);
            });
    }

    public createTable(): Promise<void> {
        const query = `
            CREATE TABLE IF NOT EXISTS ${ FtRecord.TABLENAME } (
                id TEXT PRIMARY KEY,
                object TEXT,
                isActive NUMERIC,
                wording TEXT
            );
        `;
        return this.sqlProvider.query(query, [])
            .then(async () => {
                await this.createIndexes();
            })
            .catch(reason => {
                this.logSqlError(reason);
                return null;
            });
    }

    delete(id: string): Promise<any> {
        const query = `DELETE FROM ${ FtRecord.TABLENAME } WHERE id = ?;`;
        return this.sqlProvider.query(query, [id]);
    }

    deleteAll(): Promise<any> {
        const query = `DELETE FROM ${ FtRecord.TABLENAME };`;
        return this.sqlProvider.query(query, []);
    }

    public get(id: string, hydrate: boolean = false): Promise<FtRecord> {
        throw new NotImplementedError();
    }

    public getTableName(): string {
        return FtRecord.TABLENAME;
    }

    protected rowToModel(row: any): FtRecord {
        const ftRecord = new FtRecord();
        ftRecord.id = row.id;
        ftRecord.isActive = row.isActive;
        ftRecord.object = row.object;
        ftRecord.wording = row.wording;
        return ftRecord;
    }

    public save(ftRecord: FtRecord): Promise<FtRecord> {
        const query = `
            INSERT OR REPLACE INTO ${ FtRecord.TABLENAME } (id, isActive, object, wording)
            VALUES (?, ?, ?, ?);
        `;
        const params = [
            ftRecord.id,
            ftRecord.isActive,
            ftRecord.object,
            ftRecord.wording,
        ];
        return this.sqlProvider.query(query, params)
            .then(() => {
                return ftRecord;
            })
            .catch(reason => {
                this.logSqlError(reason);
                return null;
            });
    }

    public async listByObject(object: string) {
        const query = `SELECT * FROM ${ FtRecord.TABLENAME }
                       WHERE object = ? AND isActive = 1;`;

        const params = [object];
        try {
            let data = await this.sqlProvider.query(query, params);

            const result: FtRecord[] = [];
            for (const row of data.rows) {
                result.push(this.rowToModel(row));
            }
            return result;
        } catch (reason) {
            this.logSqlError(reason);
            return null;
        }
    }
}
